import React, { MouseEvent } from 'react';
import './ToggleSwitch.pcss';
import classnames from 'classnames';

type Props = {
  isOn: boolean;
  leftSwitchText?: string;
  rightSwitchtext?: string;
  handleToggle: (event: MouseEvent<HTMLLIElement>) => void;
  classes?: {
    container?: string;
    trigger?: string;
  };
};

export const ToggleSwitch = ({
  classes,
  isOn,
  handleToggle,
  leftSwitchText,
  rightSwitchtext,
}: Props) => {
  return (
    <>
      <ul
        className={classnames(
          classes?.container,
          'toggle-switch',
          'toggle-switch--tabs',
          {
            'toggle-switch--trigger--slide': isOn,
          },
        )}
      >
        <li
          className={classnames(
            classes?.trigger,
            'toggle-switch',
            'toggle-switch--trigger',
            {
              'toggle-switch--trigger--active': !isOn,
            },
          )}
          onClick={handleToggle}
        >
          {leftSwitchText}
        </li>
        <li
          className={classnames(
            classes?.trigger,
            'toggle-switch',
            'toggle-switch--trigger',
            {
              'toggle-switch--trigger--active': isOn,
            },
          )}
          onClick={handleToggle}
        >
          {rightSwitchtext}
        </li>
      </ul>
    </>
  );
};
